// Money helpers for customer job invoicing (AUD). Values move over the wire in
// cents (integers); the UI collects dollars.
export const fmtMoney = (cents) => {
  const d = (Number(cents) || 0) / 100;
  let s = d.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  if (s.endsWith(".00")) s = s.slice(0, -3);
  return "$" + s;
};

export const toCents = (dollars) => Math.round((Number(dollars) || 0) * 100);

// Compute display totals client-side (backend remains authoritative on save).
export const computeTotals = (lineItems, discount, gstRegistered, gstMode = "exclusive") => {
  const subtotal = lineItems.reduce(
    (sum, li) => sum + Math.round((Number(li.quantity) || 0) * toCents(li.unit_price)), 0);
  let discountCents = 0;
  if (discount?.type === "percent") discountCents = Math.round(subtotal * (Number(discount.value) || 0) / 100);
  else if (discount?.type === "fixed") discountCents = toCents(discount.value);
  discountCents = Math.max(0, Math.min(discountCents, subtotal));
  const taxable = subtotal - discountCents;
  let gst = 0;
  if (gstRegistered) {
    const stdCents = lineItems.reduce(
      (s, li) => s + ((li.gst_treatment || "standard") === "standard"
        ? Math.round((Number(li.quantity) || 0) * toCents(li.unit_price)) : 0), 0);
    const share = subtotal === 0 ? 0 : stdCents / subtotal;
    const stdTaxable = Math.round(taxable * share);
    gst = gstMode === "inclusive"
      ? Math.round(stdTaxable - stdTaxable / 1.1)
      : Math.round(stdTaxable * 0.1);
  }
  const total = taxable + (gstMode === "exclusive" ? gst : 0);
  return { subtotal_cents: subtotal, discount_cents: discountCents, gst_cents: gst, total_cents: total };
};

export const STATUS_STYLES = {
  draft: "bg-slate-100 text-slate-700 border-slate-300",
  issued: "bg-blue-100 text-blue-800 border-blue-300",
  sent: "bg-indigo-100 text-indigo-800 border-indigo-300",
  unpaid: "bg-amber-100 text-amber-800 border-amber-300",
  partially_paid: "bg-amber-100 text-amber-800 border-amber-300",
  paid: "bg-emerald-100 text-emerald-800 border-emerald-300",
  overdue: "bg-red-100 text-red-800 border-red-300",
  cancelled: "bg-slate-200 text-slate-500 border-slate-300",
  refunded: "bg-purple-100 text-purple-800 border-purple-300",
};

export const statusLabel = (s) => (s || "draft").replace("_", " ").toUpperCase();
